export default function ({ state }) {
    const answers = state.get('app.answers');
    if (Object.keys(answers).length >= 6) {
        gtag('event', 'all_parts_completed', {}); // eslint-disable-line
        if (window._paq) {
            window._paq.push(['trackEvent', 'GRIP kind van', 'all_parts_completed']);
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/app/actions/trackFullCompletionEvent.js